import { useQuery } from '@tanstack/react-query';
import { stepSubmissionRequestCount } from '../api/candidates';
import { usePermission } from '../auth/usePermission';

export const STEP_SUBMISSION_REQUESTS_QUERY_KEY = ['step-submission-requests'];
export const STEP_SUBMISSION_REQUESTS_COUNT_QUERY_KEY = ['step-submission-requests', 'count'];

/** Pending workflow step-submission request count for the sidebar badge (polled, like useStepApprovalCount). */
export function useStepSubmissionCount() {
  const { can } = usePermission();
  const enabled = can('workflow.step-submission-approval');

  const query = useQuery({
    queryKey: STEP_SUBMISSION_REQUESTS_COUNT_QUERY_KEY,
    queryFn: stepSubmissionRequestCount,
    enabled,
    refetchInterval: 60_000,
  });

  return enabled ? (query.data ?? 0) : 0;
}
